import { SxProps, Theme } from '@mui/material';

/**
 * Styles for StudentProgress component
 * Uses theme values from MuiProvider for consistent styling
 */

export const studentProgressStyles = {
  // Main container for the report
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  }) as SxProps<Theme>,

  // Header section container
  headerContainer: (theme: Theme) => ({
    flexShrink: 0,
  }) as SxProps<Theme>,

  // Table section container
  tableContainer: (theme: Theme) => ({
    flexGrow: 1,
    overflow: 'auto',
  }) as SxProps<Theme>,

  // Export menu wrapper for right alignment
  exportMenuContainer: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'flex-end',
  }) as SxProps<Theme>,

  // Student column header text
  studentColumnHeader: (theme: Theme) => ({
    fontWeight: 'bold',
    fontSize: '18px',
  }) as SxProps<Theme>,

  // Student name link in table cells
  studentLink: (theme: Theme) => ({
    cursor: 'pointer',
    textAlign: 'left',
  }) as SxProps<Theme>,
};

export default studentProgressStyles;
